module.exports = __webpack_public_path__ + "img/pen-tool-2.fde0a8ec.svg";